import {
  enumConnectorStringIndex96,
  enumIconIndex,
  enumImageIndex,
  kConnectorDict,
  kVersionStr
} from "../constants";
import { WSLoadImage } from "../utils/WSLoadImage";
import { enumButtonColors, kImageFiles, uViewerButtonColor } from "../whitelabel/brand";
import { Globals } from "./Globals";
import { doDrawIcon } from "../utils/doDrawIcon.js";
import { QImageElement } from "./QImageElement.js";

export class QImageMgr {
  constructor() {
    this.fImageList = null;
    this.fLoadedImageCount = 0;
    this.fTotalImages = 0;
    this.fOffscreenBuffer;
    this.fWSMgr = null;
    this.fDisableImageCache = {};
  }

  InitImageMgr(imageFiles, wsMgr) {
    this.fWSMgr = wsMgr;
    this.fImageList = [];
    this.LoadImages(imageFiles);
    setTimeout(this.LoadWhiteViewerIconSet(), 5);
  }

  LoadGrayAppIcons() {
    var imageObj = this.fImageList[enumImageIndex.appIcons];
    var disabledBuffer = this.ConvertToGrayscaleImage(imageObj);
    this.CacheGreyImage(enumImageIndex.appIcons, disabledBuffer);
  }

  GetIndexImage(theIndex) {
    return this.fImageList[theIndex];
  }

  AddImageElement(imageIndex, iconIndex, x, y, srcWidth, srcHeight, destWidth, dstHeight, slice) {
    var imageElement = new QImageElement();
    imageElement.SizeElement(destWidth, dstHeight);
    imageElement.PositionElement(x, y);
    if (slice) imageElement.SetImageInfo(this, iconIndex, imageIndex, srcWidth, srcHeight, true);
    return imageElement;
  }

  LoadWhiteViewerIconSet() {
    var targetFile = kImageFiles[enumImageIndex.viewerIcons];
    var pathToSVG;

    var anImage = new Object();
    anImage["parentWS"] = this;

    //anImage.onload = WSLoadImage;
    anImage.type = "image/svg+xml";
    anImage.id = "viewerIcons";

    var APIServer = Globals._accountInfo.GetAPIServer();
    var baseImageURL = Globals._accountInfo.GetImageBaseUrl();
    var filePath = targetFile.charAt(0) === "/" ? targetFile.substring(1) : targetFile;
    if (baseImageURL != null) {
      var sep = baseImageURL.charAt(baseImageURL.length - 1) === "/" ? "" : "/";
      pathToSVG = baseImageURL + sep + filePath + "?v=" + kVersionStr;
    } else if (APIServer != null) {
      var sep = APIServer.charAt(APIServer.length - 1) === "/" ? "" : "/";
      pathToSVG = APIServer + sep + filePath + "?v=" + kVersionStr;
    } else pathToSVG = targetFile + "?v=" + kVersionStr;
    anImage.src = pathToSVG;
    anImage.data = pathToSVG;
    this.fImageList.push(anImage);

    var request = new XMLHttpRequest();
    request["parentWS"] = this;
    request["imageobj"] = anImage;
    request.open("GET", pathToSVG);
    request.setRequestHeader("Content-Type", "image/svg+xml");
    request.addEventListener("load", function (event) {
      var response = event.target.responseText;
      var doc = new DOMParser();
      var xml = doc.parseFromString(response, "image/svg+xml");
      var svgData = response.slice(0, response.indexOf("<svg"));
      svgData +=
        xml.documentElement.outerHTML || new XMLSerializer().serializeToString(xml.documentElement);

      var callbackObj = this.parentWS;

      var imageObj = new Image();
      imageObj.origSrc = svgData;
      svgData = callbackObj.ColorizeSVGData(imageObj, svgData);
      imageObj.src = "data:image/svg+xml," + encodeURIComponent(svgData);
      callbackObj.fImageList[enumImageIndex.viewerIcons] = imageObj;

      var disableImageObj = new Image();
      disableImageObj.origSrc = imageObj.origSrc;
      var svgData2 = callbackObj.ColorizeSVGData(disableImageObj, imageObj.origSrc, "#A9A9A9");
      disableImageObj.src = "data:image/svg+xml," + encodeURIComponent(svgData2);
      callbackObj.CacheGreyImage(enumImageIndex.viewerIcons, disableImageObj);
    });
    request.send();
  }

  UpdateViewerSVGColor() {
    var imageObj = this.fImageList[enumImageIndex.viewerIcons];
    var svgData = imageObj.origSrc;
    svgData = this.ColorizeSVGData(imageObj, svgData);
    imageObj.src = "data:image/svg+xml," + encodeURIComponent(svgData);
  }

  CacheGreyImage(imageIdx, buffer) {
    this.fDisableImageCache[imageIdx] = buffer;
  }

  ConvertToGrayscaleImage(imageObj) {
    var canvas = document.createElement("canvas"); //canvas element initialisation
    canvas.width = imageObj.width; //canvas width initialisation
    canvas.height = imageObj.height; //canvas height initialisation

    var context = canvas.getContext("2d");
    context.drawImage(imageObj, 0, 0);

    var imageData = context.getImageData(0, 0, imageObj.width, imageObj.height);
    var data = imageData.data;

    for (var i = 0; i < data.length; i += 4) {
      var brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
      // red
      data[i] = brightness;
      // green
      data[i + 1] = brightness;
      // blue
      data[i + 2] = brightness;
    }

    // overwrite original image
    context.putImageData(imageData, 0, 0);

    var grayImage = new Image();
    grayImage.src = canvas.toDataURL("image/svg");
    grayImage.onload = function () {
      Globals._wsMgr.RenderWS();
    };
    return grayImage;
  }

  ColorizeSVGData(imageObj, svgData, color) {
    var buttonColor = enumButtonColors[uViewerButtonColor];
    if (Globals._accountInfo.GetButtonColor()) buttonColor = Globals._accountInfo.GetButtonColor();
    svgData = svgData.replaceAll("white", color ? color : buttonColor);
    return svgData;
  }

  GetConnectorImage(source, type, targetW = 72, targetH = 72) {
    var connectorList = kConnectorDict[type];
    if (connectorList) {
      var index = connectorList
        .map(function (item) {
          return item["command"];
        })
        .indexOf(source);

      var theConnector = connectorList[index];
      if (theConnector) {
        var theIcon = theConnector["icon"];
        var iconIndex = enumConnectorStringIndex96[theIcon];

        var col = 7;

        var yOffset = Math.floor(iconIndex / col);
        var xOffset = iconIndex % col;

        var origW = 96;
        var origH = 96;

        return this.GetSubImage(
          enumImageIndex.enableconnectors96,
          xOffset,
          yOffset,
          targetW,
          targetH,
          origW,
          origH
        );
      }
    } else {
      return this.GetHelpImage(targetW, targetH);
    }
  }

  GetHelpImage(targetW = 72, targetH = 72) {
    return this.GetIndexImage(enumIconIndex.help);
  }

  GetSubImage(theIndex, x, y, xSize, ySize, xSpacing, ySpacing, gray) {
    // get the base image
    var svg = theIndex === enumImageIndex.viewerIcons || theIndex === enumImageIndex.appIcons;
    var mainImage = this.GetIndexImage(theIndex);

    if (gray && svg) {
      if (this.fDisableImageCache[theIndex]) {
        mainImage = this.fDisableImageCache[theIndex];
      }
    }

    // used to trim off any unwanted image data
    var antiAliasSliceAdjustmentFactor = Globals._dpr * 0.1;

    // define position and size
    var srcLeft = Math.round(x * xSpacing) + antiAliasSliceAdjustmentFactor;
    var srcTop = Math.round(y * ySpacing) + antiAliasSliceAdjustmentFactor;

    var srcWidth = Math.round(xSpacing) - antiAliasSliceAdjustmentFactor * 2;
    var srcHeight = Math.round(ySpacing) - antiAliasSliceAdjustmentFactor * 2;

    var dstWidth = Math.round(xSize);
    var dstHeight = Math.round(xSize);

    var dstTop = 0;
    var dstLeft = 0;

    // create offscreen buffer and draw it to scale
    var aCanvas = document.createElement("canvas");
    aCanvas.width = Math.floor(dstWidth * Globals._dpr);
    aCanvas.height = Math.floor(dstHeight * Globals._dpr);
    aCanvas.style.width = dstWidth + "px";
    aCanvas.style.height = dstHeight + "px";

    // draw to canvas element
    var ctx = aCanvas.getContext("2d");
    ctx.scale(Globals._dpr, Globals._dpr);
    doDrawIcon(
      ctx,
      mainImage,
      srcLeft,
      srcTop,
      srcWidth,
      srcHeight,
      dstLeft,
      dstTop,
      dstWidth,
      dstHeight,
      svg
    );
    ctx.scale(1, 1);
    return aCanvas;
  }

  GetGraySubImage(theIndex, x, y, xSize, ySize, xSpacing, ySpacing) {
    var isSVG = theIndex === enumImageIndex.viewerIcons || theIndex === enumImageIndex.appIcons;
    if (isSVG && this.fDisableImageCache[theIndex]) {
      return this.GetSubImage(theIndex, x, y, xSize, ySize, xSpacing, ySpacing, true);
    } else {
      var imageBuffer = this.GetSubImage(theIndex, x, y, xSize, ySize, xSpacing, ySpacing);
      var context = imageBuffer.getContext("2d");
      var imageData = context.getImageData(0, 0, imageBuffer.width, imageBuffer.height);
      var data = imageData.data;

      for (var i = 0; i < data.length; i += 4) {
        var brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
        // red
        data[i] = brightness;
        // green
        data[i + 1] = brightness;
        // blue
        data[i + 2] = brightness;
      }
      // overwrite original image
      context.putImageData(imageData, 0, 0);
      return imageBuffer;
    }
  }

  LoadImages(imageFiles) {
    if (imageFiles == null) return;

    var n = imageFiles.length;
    this.fTotalImages = n;

    for (var i = 0; i < n; i++) {
      var anImage = new Image();
      anImage["parentWS"] = this;
      anImage["index"] = i;
      anImage.onload = WSLoadImage;
      anImage.onerror = function () {
        console.warn("QImageMgr: failed to load image", this.src);
        WSLoadImage.call(this);
      };
      var APIServer = Globals._accountInfo.GetAPIServer();
      var baseImageURL = Globals._accountInfo.GetImageBaseUrl();
      var filePath = imageFiles[i].charAt(0) === "/" ? imageFiles[i].substring(1) : imageFiles[i];
      if (baseImageURL != null) {
        var sep = baseImageURL.charAt(baseImageURL.length - 1) === "/" ? "" : "/";
        anImage.crossOrigin = "anonymous";
        anImage.src = baseImageURL + sep + filePath + "?v=" + kVersionStr;
      } else if (APIServer != null) {
        var sep = APIServer.charAt(APIServer.length - 1) === "/" ? "" : "/";
        anImage.crossOrigin = "anonymous";
        anImage.src = APIServer + sep + filePath + "?v=" + kVersionStr;
      } else anImage.src = imageFiles[i] + "?v=" + kVersionStr;
      this.fImageList.push(anImage);
    }
  }

  ImageLoaded(imgidx) {
    this.fLoadedImageCount++;
    if (imgidx === enumImageIndex.appIcons) setTimeout(this.LoadGrayAppIcons(), 5);
    //	console.log("QImageMgr:ImageLoad:",this.fLoadedImageCount)
    if (this.fLoadedImageCount == this.fTotalImages) this.fWSMgr.LoadComplete();
  }
}
